import {Injectable, inject} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { App as CapacitorApp } from '@capacitor/app';
import {fromEventPattern, Subscription} from 'rxjs';
import {Location} from '@angular/common';
import {ExitAppComponent} from '@components/exit-app/exit-app.component';

@Injectable({ providedIn: 'root' })
export class BackButtonHandlerService {
  private readonly _dialog = inject(MatDialog);
  private readonly _router = inject(Router);
  private readonly _location = inject(Location);
  private _backButtonSub: Subscription | null = null;
  private readonly _exitRoutes = ['/tabs/collection'];

  startListening(): void {
    if (this._backButtonSub) return;
    const backButton$ = fromEventPattern<{ canGoBack: boolean }>(
      handler => CapacitorApp.addListener('backButton', handler),
      () => {}
    );
    this._backButtonSub = backButton$.subscribe(({ canGoBack }) => {
      const currentUrl = this._router.url;
      if (this._exitRoutes.includes(currentUrl)) {
        this._openExitDialog();
      } else if (canGoBack) {
        this._location.back();
      }
    });
  }

  public stopListening(): void {
    this._backButtonSub?.unsubscribe();
    this._backButtonSub = null;
  }

  private _openExitDialog(): void {
    this._dialog.open(ExitAppComponent, { width: '300px' });
  }
}
